export function formatDecimal(value, max_places) {
  return Number(value).toLocaleString("pt-PT", {
    style: "decimal",
    maximumFractionDigits: max_places
  });
}